/**
 * SPDX-License-Identifier: MIT
 * Copyright (c) 2026 Solvetia. Original work by Solvetia — part of the Solvetia
 * white-label additions to Chatwoot Community Edition (MIT). Not derived from
 * the commercial code under enterprise/.
 */
/**
 * Maps the Settings → Branding form fields to the custom_attributes keys
 * the backend expects. Blank values are included on purpose: sending ''
 * overwrites (clears) a previously-set branding value via the backend merge.
 */
export function buildBrandingPayload(form) {
  return {
    brand_name: form.brandName,
    brand_color: form.brandColor,
    logo_url: form.logoUrl,
    logo_dark_url: form.logoDarkUrl,
    favicon_url: form.faviconUrl,
  };
}
